import { useEffect, useState} from "react";
import DataTable from "../../utils/DataTable";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
export default function ViewBatches({title}){
   
   const dispatch=useDispatch()
   const loading=useSelector((state)=>state.loader.loading)
   const isOpen=useSelector((state)=>state.modal.isOpen)
   const [status,setStatus]=useState(1)
   const batches=useSelector((state)=>state.data.data)
    return(
        <>
            <div className="container">
                <div className="page-inner">
                {
                    loading && !isOpen? 
                        <Loader/>
                        :
                    <>
                        <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                            <div>
                            <h3 className="fw-bold mb-3">{title}</h3>
                            {/* <select className="form-select" onChange={(e)=>{setStatus(e.target.value)}} value={status}>
                                <option value={1}>Currrent</option>
                                <option value={2}>Archive</option>
                            </select> */}
                            </div>
                        </div>
                        <div className="container">
                            <div className="row">
                                {
                                    batches?.length>0?
                                    batches?.map((el,index)=>(
                                        <div className="col-sm-6 text-capitalize col-md-4 col-lg-3 col-12">
                                            <div className="card p-3">
                                                <h4 className="">{el?.batchId?.name}</h4>
                                                <div className="">{el?.batchId?.time}</div>
                                            </div>
                                        </div>
                                    ))
                                    :
                                    <h1>No Batch Found!!</h1>
                                }
                              
                            </div>
                        </div>
                    </>
                }
                </div>
            </div>
        </>
    )
}